import { render, staticRenderFns } from "./ExtendedVideo.Dialog.vue?vue&type=template&id=1473c626&scoped=true&"
import script from "./ExtendedVideo.Dialog.vue?vue&type=script&lang=js&"
export * from "./ExtendedVideo.Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1473c626",
  null
  
)

export default component.exports